module.exports = __webpack_public_path__ + "static/media/house-gray.73990545.svg";